/**
 * User-friendly loading message stages and progress-based message selection.
 */

export interface MessageStage {
  minProgress: number;
  maxProgress: number;
  messages: string[];
}

export const MESSAGE_STAGES: MessageStage[] = [
  {
    minProgress: 0,
    maxProgress: 20,
    messages: [
      "Preparing your workspace...",
      "Setting up the environment...",
      "Initializing core systems...",
    ],
  },
  {
    minProgress: 20,
    maxProgress: 50,
    messages: [
      "Loading application features...",
      "Configuring your workspace...",
      "Setting up services...",
    ],
  },
  {
    minProgress: 50,
    maxProgress: 80,
    messages: [
      "Almost there...",
      "Finalizing setup...",
      "Preparing the interface...",
    ],
  },
  {
    minProgress: 80,
    maxProgress: 100,
    messages: ["Welcome to Rusha!", "Ready to go!", "All set!"],
  },
];

/**
 * Get current user-friendly message based on overall progress percentage.
 */
export const getMessageForProgress = (progress: number): string => {
  const stage =
    MESSAGE_STAGES.find(
      (s) => progress >= s.minProgress && progress < s.maxProgress,
    ) || MESSAGE_STAGES[MESSAGE_STAGES.length - 1];

  // Select a message from the stage (can be randomized or based on progress)
  const messageIndex = Math.floor(
    ((progress - stage.minProgress) / (stage.maxProgress - stage.minProgress)) *
      stage.messages.length,
  );
  return (
    stage.messages[Math.min(messageIndex, stage.messages.length - 1)] ||
    stage.messages[0]
  );
};
